import styled from 'styled-components';

export default styled.div`
  display: inline-block;
  opacity: ${({ isActive = true }) => (isActive ? 0.5 : 0.2)};
  text-transform: uppercase;
  margin: 3px 5px 3px 0;
`;
